<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-read-group-label-input :inputValue="host" v-if="tb == '1'"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-read-group-label-input>
        <form-write-group-label-input v-model="host" disabled :isMandatory="tb == '1'" v-else
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-read-group-label-input :inputValue="port" v-if="tb == '1'"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-read-group-label-input>
        <form-write-group-label-input v-model="port" isMandatory :disabled="(readonly) || (tb == '1')" v-else
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <form-write-group-label-input  v-model="timeout" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.timeout')" :placeholderValue="$t('common.routing.timeout')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''  && tb != '1'">
        <form-write-group-label-input v-model="formatName" disabled
          :inputLabel="$t('common.routing.format_name')" :placeholderValue="$t('common.routing.format_name')">
        </form-write-group-label-input>
      </b-col>


      <b-col sm="6" class="form-group mt-4" v-if="tb == '1'">
        <span class="my-2">
          <span class="filter-item-title">{{ $t('certificates.details_certificate') }}</span>
          <span class="color-red">* </span>
        </span>
        <br>
        <b-col sm="12" :disabled="(readonly)" :class="CertificateInput ? 'my-2' : 'pl-0'">
          <b-col sm="12 p-0 my-3">
<!--            <input v-if="!readonly" class="p-0" type="file" @change="handleFileUploadCertificat($event)" accept=".crt" />-->

            <b-row class="m-0">
              <b-col>
                <form-write-group-label-input v-model="OrganisationIdentifier" @input="resetFieldForm()"
                                              :inputLabel="$t('certificates.organisation_identifier')" :placeholderValue="$t('certificates.organisation_identifier')">
                </form-write-group-label-input>
              </b-col>
              <b-col>
                <form-write-group-label-input v-model="Country" @input="resetFieldForm()"
                                              :inputLabel="$t('administration.country')" :placeholderValue="$t('administration.country')">
                </form-write-group-label-input>
              </b-col>
            </b-row>




            <!-- Checkboxes exclusives -->
            <div v-if="hasMainFile" class="mt-2">
              <label class="ml-3">
                <input type="checkbox" v-model="isStandard" @change="emitValidity" />
                {{ $t('certificates.qwac_psd2') }}
              </label>
              <label>
                <input type="checkbox" v-model="isQwacLike" @change="emitValidity" />
                {{ $t('certificates.qwac_psd2_mimicked') }}
              </label>
            </div>

            <!-- Fichier AC si Qwac Like -->
            <div v-if="isQwacLike">

              <div class="ml-2 alert d-flex align-items-center" disabled role="alert" style="color: #000000;background-color: rgb(236,236,236);">
                {{ $t('certificates.qwac_psd2_mimicked_info') }}
              </div>
              <input type="file" @change="handleFileUploadAC" accept=".pem" />
            </div>
          </b-col>

          <br>

          <!-- Détails de l'Autorité de Certification -->
          <div v-if="ACFile" class="certificate-details">
          <span>
            <span class="filter-item-title">{{ $t('certificates.details_ca_client') }}</span>
            <span class="color-red">* </span>
          </span>
            <br>

            <b-col  sm="12" v-if="ACFile" class="certificate-details">
              <b-row class="d-flex justify-content-center align-items-center">
                <b-col sm="12">
                  <!-- Affichage des certificats CA concaténés -->
                  <details class="mt-4">
                    <summary class="w-50 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_ca_certificates') }}</summary>
                    <pre class="p-2 bg-light text-monospace">{{ decodeACFile()  }}</pre>
                  </details>
                </b-col>
              </b-row>
            </b-col>

          </div>

          <b-col sm="6" class="my-3 p-0">
            <b-button v-if="!readonly" class="justify-item-end responsive-button"
                      @click="openPopup('output')" variant="primary">
              <i class="fa-light fa-plus "></i>
              <span>{{$t('entities_setting_tb.generate_certificat')}}</span>
            </b-button>
          </b-col>
          <certificate-pop-up v-if="showModal" @close="closePopup" @savepopup="submitForm" :form="form" ></certificate-pop-up>
          <br>
          <!-- Affichage des données extraites -->

          <b-col sm="12" class="p-0" v-if="CertificateInput">
            <b-row class="m-0">
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.deliveredTo !== ''"
                    :inputLabel="$t('certificates.common_name')"
                    :inputValue="CertificateInput.deliveredTo">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.deliveredBy !== ''"
                    :inputLabel="$t('certificates.issued_by')"
                    :inputValue="CertificateInput.deliveredBy">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.startDate !== ''"
                    :inputLabel="$t('certificates.valid_from')"
                    :inputValue="CertificateInput.startDate">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="2" class="p-0" v-if="CertificateInput">
                <form-read-group-label-input
                    v-if="CertificateInput.endDate !== ''"
                    :inputLabel="$t('certificates.valid_until')"
                    :inputValue="CertificateInput.endDate">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="p-0" v-else>
            <b-row class="m-0">
              <b-col sm="12" class="p-0">
                <div class="d-flex justify-content-left">
                      <span class="noResult">
                        {{ $t('common.no_certificate') }}
                      </span>
                </div>
              </b-col>
            </b-row>
          </b-col>

          <b-row class="mx-1">
            <b-col sm="6" class="p-0" v-if="CertificateInput">
              <!-- Affichage du certificat au format PEM -->
              <details class="mt-3 w-100">
                <summary class="w-75 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_certificate') }}</summary>
                <pre class="p-2 bg-light text-monospace">{{ CertificateInput.certificate }}</pre>
              </details>
            </b-col>

            <b-col sm="6" class="p-0 d-flex justify-content-end" v-if="CertificateInput">
              <b-button v-if="CertificateInput.certificate"
                  variant="primary"
                  class="mt-3 px-3 py-2 d-inline-block w-75"
                  @click="downloadCertificate(CertificateInput.certificate)"
              >
                {{ $t('certificates.download_certificate') }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <!-- Affichage des données extraites -->
      </b-col>


      <b-col sm="6" v-if="tb == '1'" class="form-group d-flex flex-column mt-4">

        <br>

        <!-- Détails de l'Autorité de Certification -->
        <div v-if="CAServer" class="certificate-details">
          <span>
            <span class="filter-item-title">{{ $t('certificates.details_ca_server') }}</span>
            <span class="color-red">* </span>
          </span>
          <br>

          <b-col  sm="12" v-if="CertificatServerParsed" class="certificate-details">
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col sm="12">
                <!-- Affichage des certificats CA concaténés -->
                <details class="mt-4">
                  <summary class="w-50 btn btn-primary d-inline-block px-3 py-2 rounded">{{ $t('certificates.view_ca_certificates') }}</summary>
                  <pre class="p-2 bg-light text-monospace">{{ CAServer }}</pre>
                </details>
              </b-col>
            </b-row>
          </b-col>

        </div>
      </b-col>

      <certificate-pop-up v-if="showModal && tb == '1'" @close="closePopup" @savepopup="submitForm" :form="form" ></certificate-pop-up>
<!--      <b-col sm="6" class="form-group" v-if="formatName != '' && formatOutName != ''">-->
<!--        <form-write-group-label-input :input-value="formatOutName" disabled-->
<!--          :inputLabel="$t('common.routing.format_out_name')" :placeholderValue="$t('common.routing.format_out_name')">-->
<!--        </form-write-group-label-input>-->
<!--      </b-col>-->
      <b-col sm="6" class="form-group" v-if="tb != '1'">
        <label for="ssl-active">
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly" id="ssl-active">
          <option v-if="sslActive != '0'" :value="sslActive"> {{ $t('common.routing.yes') }} </option>
          <option v-else value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0"> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col v-if="sslActive != '0' && tb != '1'" sm="6" class="form-group">
        <label for="keystore">
          {{ $t('common.routing.keystore') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="keystore" :disabled="readonly" id="keystore">
          <option v-for="keystore in keystoreList" :key="keystore.id" :value="keystore.id"> {{ keystore.name }} </option>
        </select>
      </b-col>
      <b-col sm="6" v-if="sslActive != '0' && tb != '1'" class="form-group">
        <label for="ca">
          {{ $t('common.routing.certificat') }}
<!--          <span class="color-red"> * </span>-->
        </label>
        <select class="form-control" v-model="ca" :disabled="readonly" id="ca">
          <option v-for="ca in caList" :key="ca.id" :value="ca.id"> {{ ca.name }} </option>
        </select>
      </b-col>
    </b-row>
    <level-control-form v-if="sslActive === '1'  && tb != '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementWebService"></level-control-form>
    <form-accordion v-if="ExtractDataFromCertificat !== '' && tb != '1'" :title="$t('common.global.authentification_certificat')" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="ExtractDataFromCertificat" isMandatory disabled
            :inputLabel="$t('common.routing.extract_data_from_certificat')" :placeholderValue="$t('common.routing.extract_data_from_certificat')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </form-accordion>
    <form-accordion v-if="ExtractDataFromHeader !== '' && tb != '1'" :title="$t('common.global.authentification_header')" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="ExtractDataFromHeader" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.extract_data_from_header')" :placeholderValue="$t('common.routing.extract_data_from_header')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </form-accordion>
  </div>
</template>
<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import {errorMessageAlert} from '@/helpers/alert'
import forge from "node-forge";
import CertificatePopUp from "@/popups/security/CertificatePopUp.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {downloadFileWithDefinedHeaders} from "@/helpers/download"

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    FormReadGroupLabelInput,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': FormReadGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'certificate-pop-up': CertificatePopUp
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    tb: {
      type: String,
      default: "0"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    CertificatServer: {
    },
    PrivateKeyServer: {
    },
    CAServer: {
    },

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    formatName: {
      get () {
        return this.inputValue.formatName || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          formatName: val,
        }
      }
    },
    formatOutName: {
      get () {
        return this.inputValue.formatOutName || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          formatOutName: val,
        }
      }
    },
    name: {
      get () {
        return this.inputValue.name || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          name: val,
        }
      }
    },
    host: {
      get () {
        return this.inputValue.host || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          host: val,
        }
      }
    },
    port: {
      get () {
        return this.inputValue.port || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          port: val,
        }
      }
    },
    sslActive: {
      get () {
        return this.inputValue.sslActive || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          sslActive: val,
        }
      }
    },
    keystore: {
      get () {
        return this.inputValue.keystore || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          keystore: val,
        }
      }
    },
    ca: {
      get () {
        return this.inputValue.sslActive || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          ca: val,
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          controlConfig: val,
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          certificateConfig: val,
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          privateKeysConfig: val,
        }
      }
    },
    timeout:{
      get () {
        return this.inputValue.timeout || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          timeout: val,
        }
      }
    },
    ExtractDataFromCertificat:{
      get () {
        return this.inputValue.ExtractDataFromCertificat || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          ExtractDataFromCertificat: val,
        }
      }
    },
    IdAuthCert:{
      get () {
        return this.inputValue.IdAuthCert || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          IdAuthCert: val,
        }
      }
    },
    ExtractDataFromHeader:{
      get () {
        return this.inputValue.ExtractDataFromHeader || ''
      },
      set (val) {
        this.inputValue = {
          ExtractDataFromHeader: val,
          ...this.inputValue,
        }
      }
    },
    IdAuthHeader:{
      get () {
        return this.inputValue.IdAuthHeader || ''
      },
      set (val) {
        this.inputValue = {
          IdAuthHeader: val,
          ...this.inputValue,
        }
      }
    },
    IdVopProvider:{
      get () {
        return this.inputValue.IdVopProvider || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          IdVopProvider: val,
        }
      }
    },
    Cert:{
      get () {
        return this.inputValue.Cert || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          Cert: val,
        }
      }
    },
    OrganisationIdentifierData:{
      get () {
        return this.inputValue.OrganisationIdentifierData || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          OrganisationIdentifierData: val
        }
      }
    },
    C:{
      get () {
        return this.inputValue.C || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          C: val
        }
      }
    },
    CertType: {
      get () {
        return this.inputValue.CertType || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          CertType: val
        }
      }
    },
    isStandard: {
      get() {
        return this.CertType === 'STANDARD'
      },
      set(value) {
        if (value) {
          this.CertType = 'STANDARD'
        } else if (this.CertType === 'STANDARD') {
          this.CertType = ''
        }
      }
    },
    isQwacLike: {
      get() {
        return this.CertType === 'QWAC_LIKE'
      },
      set(value) {
        if (value) {
          this.CertType = 'QWAC_LIKE'
        } else if (this.CertType === 'QWAC_LIKE') {
          this.CertType = ''
        }
      }
    },
    ACFile: {
      get () {
        return this.inputValue.ACFile || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          ACFile: val
        }
      }
    }
  },
  data () {
    return {
      hasMainFile: false,
      hasCountry: false,
      hasACFile: false,
      caList: [],
      keystoreList: [],
      vopProviderList: [],
      CertificateInput: null,
      PrivateKeyInput: null,
      certificateGenerated: false,
      CertificatServerParsed: null,
      form: {
        C: "",
        O: "",
        CN: "",
        CIB: "",
        subjectAltName: "",
        mode: "clientAuth",
        L: "",
        siren: ""
      },
      subjectAltNameValue: "",
      isSubjectAltNameEditable: true,
      showModal: false,
      Country: '',
      OrganisationIdentifier: '',
    }
  },
  created () {
    if (this.value.Country != ''){
      this.hasCountry = true
      this.Country = this.value.Country
    }
    if (this.value.OrganisationIdentifier != '') {
      this.hasMainFile = true
      this.OrganisationIdentifier = this.value.OrganisationIdentifier

      if (this.CertType !== 'STANDARD' && this.CertType !== '') {
        this.CertType = 'QWAC_LIKE'
      } else if (this.CertType === 'STANDARD') {
        this.CertType = 'STANDARD'
      }
    }
    if (this.tb != '1') {
      if (this.mode === 'create') {
        if (this.prefilledURI !== undefined || this.prefilledURI === '') {
          this.inputValue.uri = this.prefilledURI
        }
        this.inputValue.sslActive = '0'
      }
      this.getCA()
      this.getKeyStore()
      this.getVopProvider()
    }else{
      this.CertificatServerParsed = this.parseCertificate(this.CAServer)
      if(this.CertificatServer != '$NotFound' || this.CertificatServer != '') {
        this.CertificateInput = this.parseCertificate(this.CertificatServer)
      }
      if(this.PrivateKeyServer != '$NotFound' || this.PrivateKeyServer != '') {
        this.PrivateKeyInput = this.parsePrivateKey(this.PrivateKeyServer)
      }
    }
    if (this.ACFile != '' && this.isQwacLike){
      this.hasACFile = true
    }else{
      this.hasACFile = false
    }
  },
  watch: {
    Country (newVal) {
      this.hasCountry = newVal != ''
      this.inputValue.Country = newVal
    },
    OrganisationIdentifier (newVal) {
      this.hasMainFile = newVal != ''
      this.inputValue.OrganisationIdentifier = newVal
      this.$emit('cn-create', newVal)
    },
    isQwacLike() {
      this.emitValidity();
    },
    isStandard() {
      this.emitValidity();
    },
    hasMainFile() {
      this.emitValidity();
    },
    hasACFile() {
      this.emitValidity();
    },
    hasCountry() {
      this.emitValidity();
    },
  },
  methods: {
    decodeACFile() {
      if (!this.ACFile || typeof this.ACFile !== 'string') {
        return '';
      }

      try {

        let base64;

        // Cas 1 : data URI base64
        if (this.ACFile.startsWith('data:application')) {
          base64 = this.ACFile.split(',')[1];
        } else {
          // Cas 2 : chaîne base64 directe
          base64 = this.ACFile.includes(',') ? this.ACFile.split(',')[1] : this.ACFile;
        }

        let decoded = atob(base64);

        // Nettoyage
        if (decoded.includes('\\n')) {
          decoded = decoded.replace(/\\n/g, '\n');
        }

        if (decoded.startsWith('"') && decoded.endsWith('"')) {
          decoded = decoded.slice(1, -1);
        }

        return decoded;
      } catch (err) {
        return 'Erreur de décodage';
      }
    },

    emitValidity() {
      let that = this
      const isValid =
        that.certificateGenerated || (
          that.hasMainFile &&
          (that.isQwacLike || that.isStandard) &&
          (!that.isQwacLike || that.hasACFile) &&
          that.hasCountry
        );

      that.$emit('validity-changed', isValid)
    },
    handleFileUploadAC(event) {
      const file = event.target.files[0]
      this.hasACFile = !!file
      if (!file) return

      const reader = new FileReader()
      reader.onload = () => {
        try {
          const pemData = reader.result

          const certs = this.extractCertsFromPem(pemData).map(pem => forge.pki.certificateFromPem(pem))

          // 1. Vérifie CA:TRUE sauf pour la feuille
          for (let i = 0; i < certs.length; i++) {
            const ext = certs[i].getExtension('basicConstraints')

            if (ext && !ext.cA) {
              throw new Error(`One of the certificates is an end-entity certificate`)
            }
          }

          const chain = this.sortCertChain(certs)


          this.ACFile = `data:application/x-x509-ca-cert;base64,${btoa(chain.map(cert => forge.pki.certificateToPem(cert)).join('\n'))}`

          this.emitValidity()

        } catch (err) {
          this.hasACFile = false
          this.$f7.alert(err.message, 'Error while parsing the certificate:')
        }
      }

      reader.readAsText(file)
    },
    getSubjectKeyIdentifier(cert) {
      const ext = cert.getExtension('subjectKeyIdentifier')
      return ext?.subjectKeyIdentifier || null
    },
    getAuthorityKeyIdentifier(cert) {
      const ext = cert.getExtension('authorityKeyIdentifier')
      return ext?.keyIdentifier || null
    },
    findIssuerByAKI(cert, allCerts) {
      const aki = this.getAuthorityKeyIdentifier(cert)
      if (!aki) return null

      return allCerts.find(c => {
        const ski = this.getSubjectKeyIdentifier(c)
        return ski && forge.util.bytesToHex(ski) === forge.util.bytesToHex(aki)
      })
    },
    sortCertChain(certs) {

      // Trouver la feuille : celle qui n'est jamais référencée comme autorité
      const allAKI = certs.map(this.getAuthorityKeyIdentifier).filter(Boolean).map(bytes => forge.util.bytesToHex(bytes))

      const leafAki = certs.find(cert => {
        const ski = this.getSubjectKeyIdentifier(cert)
        return ski && !allAKI.includes(forge.util.bytesToHex(ski))
      })

      if (!leafAki) throw new Error("Incomplete certificate chain (missing certificate)")

      const subjectMap = new Map()
      const issuerMap = new Map()

      for (const cert of certs) {
        const subject = cert.subject.hash
        const issuer = cert.issuer.hash

        subjectMap.set(subject, cert)
        if (!issuerMap.has(issuer)) issuerMap.set(issuer, [])
        issuerMap.get(issuer).push(cert)
      }

      // Trouver le certificat feuille (qui n’est jamais un issuer)
      const leaf = certs.find(cert => {
        const subject = cert.subject.hash
        return !issuerMap.has(subject) || issuerMap.get(subject).every(c => c === cert)
      })

      if (!leaf) throw new Error("Incomplete certificate chain (missing root certificate)")

      // Reconstruire la chaîne vers le haut
      const chain = [leaf]
      let current = leaf

      while (true) {
        const issuer = current.issuer.hash
        if (issuer === current.subject.hash) break // racine trouvée
        const parent = subjectMap.get(issuer)
        if (!parent) throw new Error("Invalid certificate chain (too many certificates)")
        chain.push(parent)
        current = parent
      }

      // taille de subjectMap doit être égale à taille de chain

      if (certs.length !== chain.length) {
        throw new Error("Multiple CAs detected")
      }

      return chain
    },
    extractCertsFromPem(pemData) {
      const regex = /-----BEGIN CERTIFICATE-----[^-]+-----END CERTIFICATE-----/g
      const matches = pemData.match(regex)
      if (!matches || matches.length === 0) {
        console.error("No PEM certificate found")
      }
      return matches
    },
    openPopup() {
      this.inputValue = {
        ...this.inputValue,
        Country: '',
        OrganisationIdentifier: '',
        OrganisationIdentifierData: ''
      }
      this.Country = ''
      this.OrganisationIdentifier = ''
      this.hasMainFile = false

      this.showModal = true
    },
    closePopup() {
      this.showModal = false
    },
    normalizeSubjectAltName(value) {
      if (!value) return ""

      const cleanedValue = value.trim()

      if (!cleanedValue) return ""

      const withoutPrefix = cleanedValue.replace(/^DNS:/i, "").trim()

      return `DNS:${withoutPrefix}`
    },
    submitForm() {
      let that = this

      that.hasMainFile = false

      that.form.subjectAltName = that.normalizeSubjectAltName(that.form.subjectAltName)

      this.inputValue = {
        formatName: this.inputValue.formatName,
        formatOutName: this.inputValue.formatOutName,
        name: this.inputValue.name,
        host: this.inputValue.host,
        port: this.inputValue.port,
        sslActive: this.inputValue.sslActive,
        keystore: this.inputValue.keystore,
        ca: this.inputValue.ca,
        controlConfig: this.inputValue.controlConfig,
        certificateConfig: this.inputValue.certificateConfig,
        privateKeysConfig: this.inputValue.privateKeysConfig,
        timeout: this.inputValue.timeout,
        ExtractDataFromCertificat: '',
        IdAuthCert: this.inputValue.IdAuthCert,
        ExtractDataFromHeader: '',
        IdAuthHeader: this.inputValue.IdAuthHeader,
        IdVopProvider: this.inputValue.IdVopProvider,
        Cert: '',
        Country: '', // <=== reset ici
        OrganisationIdentifier: '', // <=== reset ici
        OrganisationIdentifierData: '', // si besoin
        C: '',
      }

      that.$engine.routing.config.webService.generateCertificatQwacLike(that.form)
          .then(resp => {
            if (!resp.data.certificate || !resp.data.key) {
              console.error("❌ Erreur : Certificat ou clé privée manquants !")
              return
            }


            that.$emit('validity-changed', true)

            // Décoder le Base64
            const decodedCert = atob(resp.data.certificate)
            const decodedKey = atob(resp.data.key)

            that.closePopup()
            that.$f7.confirm(
                that.$t('account_tb.certificate_generated'),
                that.$t('account_tb.certificate'),
                () => {
                  that.downloadBase64File(resp.data.certificate, 'certificat.crt', 'application/x-x509-ca-cert')

                  that.$f7.confirm(
                      that.$t('account_tb.download_private_key'),
                      that.$t('account_tb.private_key'),
                      () => {
                        that.downloadBase64File(resp.data.key, 'private_key.key', 'application/x-pem-file')
                      }
                  )
                }
            )


            try {
              const certificate = forge.pki.certificateFromPem(decodedCert)
              const pemFormattedCert = forge.pki.certificateToPem(certificate)

              this.inputValue.CertificateText = pemFormattedCert

              const orgIdAttr = certificate.subject.attributes.find(attr => attr.type === '2.5.4.97')

              let orgIdentifier = 'Inconnu'
              let orgIdOnly = null

              if (orgIdAttr && orgIdAttr.value) {
                orgIdentifier = orgIdAttr.value
                this.$emit('cn-create', orgIdentifier)
                const parts = orgIdentifier.split('-')
                orgIdOnly = parts[parts.length - 1] // récupère juste le "15930"
              }

              that.inputValue.OrganisationIdentifierData = orgIdOnly != null ? orgIdentifier : null


              // Formatage des dates (YYYY-MM-DD)
              const startDate = certificate.validity.notBefore.toISOString().split('T')[0]
              const endDate = certificate.validity.notAfter.toISOString().split('T')[0]

              // Fonction pour récupérer les valeurs des attributs
              const getAttributeValue = (attributes, name) => {
                const attr = attributes.find(attr => attr.name === name)
                return attr ? attr.value : 'Inconnu'
              }

              // Récupération des informations
              const deliveredBy = getAttributeValue(certificate.issuer.attributes, 'commonName')
              const deliveredTo = getAttributeValue(certificate.subject.attributes, 'commonName')

              // Création de l'objet CertificateInput
              const CertificateInput = {
                certificate: pemFormattedCert,  // Contenu du certificat en PEM
                startDate,                      // Date de début de validité
                endDate,                        // Date de fin de validité
                deliveredBy,                    // Émetteur du certificat
                deliveredTo,                    // Destinataire (CN)
                nameDisplay: deliveredTo         // Affichage du nom (même que deliveredTo)
              }

              that.ExtractDataFromHeader = deliveredTo

              // Mise à jour de la data en fonction de index
              that.CertificateInput = CertificateInput
              that.PrivateKeyInput = decodedKey
              that.Cert = {Cert: decodedCert, Key: decodedKey}
              that.certificateGenerated = true

              that.emitValidity()


            } catch (err) {
              console.error(that.$i18n.t('common.security.pem_certificate_parsing_error'), err)
            }
          })
          .catch(e => {
            errorMessageAlert(e, that)
            that.okMessageBox(that.$t('common.routing.config_addition_error'))
          })
    },
    downloadBase64File(base64Data, filename, mimeType) {
      try {
        // Décodage du base64 en bytes
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);

        downloadFileWithDefinedHeaders(this, filename, blobUrl);
      } catch (err) {
        console.error('Erreur lors de la conversion base64 en fichier :', err);
      }
    },
    downloadCertificate(certificate) {
      // Téléchargement du certificat
      let blobCert = new Blob([certificate], { type: 'application/x-pem-file;charset=utf-8' });
      let blobUrlCert = URL.createObjectURL(blobCert);
      downloadFileWithDefinedHeaders(this, 'certificate.crt', blobUrlCert);

      // Téléchargement de la clé privée
      if (this.PrivateKeyInput?.privateKey) {
        let blobKey = new Blob([this.PrivateKeyInput.privateKey], { type: 'application/x-pem-file;charset=utf-8' });
        let blobUrlKey = URL.createObjectURL(blobKey);
        downloadFileWithDefinedHeaders(this, 'private-key.key', blobUrlKey);
      } else {
        console.warn('Aucune clé privée trouvée dans PrivateKeyInput.');
      }
    },
    handleFileUploadCertificat(event, index = null) {
      this.hasMainFile = event.target.files.length > 0
      const file = event.target.files[0]
      const reader = new FileReader()


      reader.onload = (e) => {
        const pemContent = e.target.result

        try {
          const certRegex = /-----BEGIN CERTIFICATE-----[\s\S]+?-----END CERTIFICATE-----/g

          const certMatch = pemContent.match(certRegex)?.[0]

          if (!certMatch) throw new Error("Invalid uploaded file")

          const certificate = forge.pki.certificateFromPem(certMatch)
          const pemFormattedCert = forge.pki.certificateToPem(certificate)

          const orgIdAttr = certificate.subject.attributes.find(attr => attr.type === '2.5.4.97')

          let orgIdentifier = 'Inconnu'
          let orgIdOnly = null

          if (orgIdAttr && orgIdAttr.value) {
            orgIdentifier = orgIdAttr.value
            const parts = orgIdentifier.split('-')
            orgIdOnly = parts[parts.length - 1] // récupère juste le "15930"
          }

          console.log('organizationIdentifier complet :', orgIdentifier)
          console.log('Identifiant extrait :', orgIdOnly)

          this.inputValue.CertificateText = pemFormattedCert

          const startDate = certificate.validity.notBefore.toISOString().split('T')[0]
          const endDate = certificate.validity.notAfter.toISOString().split('T')[0]

          const getAttributeValue = (attributes, name) => {
            const attr = attributes.find(attr => attr.name === name)
            return attr ? attr.value : 'Inconnu'
          }

          const deliveredBy = getAttributeValue(certificate.issuer.attributes, 'commonName')
          const deliveredTo = getAttributeValue(certificate.subject.attributes, 'commonName')

          this.$emit('cn-create', deliveredTo)

          const CertificateInput = {
            certificate: pemFormattedCert,
            startDate,
            endDate,
            deliveredBy,
            deliveredTo,
            nameDisplay: deliveredTo
          }

          this.ExtractDataFromHeader = deliveredTo

          if (index == null) {
            this.CertificateInput = CertificateInput
            this.Cert = {Cert: certMatch}
          } else {
            this.inputValue.CertificatList[index] = CertificateInput
          }

        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
        }
      }



      reader.readAsText(file)
    },
    getCA () {
      let that =this
      this.$engine.security.ca.fetch()
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca
        this.caList = CAList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getKeyStore () {
      let that = this
      this.$engine.security.keystore.fetch()
      .then(resp => {
        let privateKeysList = {}

        privateKeysList = resp.data.keystore

        this.keystoreList = privateKeysList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getVopProvider () {
      let params = {}
      let that = this
      this.$engine.vopProvider.getVopProvider(params).then((resp) => {
        this.vopProviderList = resp.data.VopProvider.map(vopProvider => ({
          id: vopProvider.IdVopProvider,
          text: vopProvider.NameVopProvider,
          value: vopProvider.NameVopProvider
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    parseCertificate (pemCert) {
      try {
        const cert = forge.pki.certificateFromPem(pemCert)
        return {
          certificate: pemCert,  // Contenu du certificat en PEM
          startDate: cert.validity.notBefore.toISOString().split('T')[0],
          endDate: cert.validity.notAfter.toISOString().split('T')[0],
          deliveredBy: this.getAttributeValue(cert.issuer.attributes, 'commonName'),
          deliveredTo: this.getAttributeValue(cert.subject.attributes, 'commonName'),
        };
      } catch (err) {
        console.error("Erreur de parsing du certificat :", err);
        return null;
      }
    },
    parsePrivateKey(pemKey) {
      try {
        const privateKey = forge.pki.privateKeyFromPem(pemKey)

        // Ici on n'a pas de validité, ni d'issuer/destinaire comme dans un certificat,
        // mais tu peux extraire un "fingerprint" ou une info simplifiée
        return {
          privateKey: pemKey, // Contenu brut PEM
          keyType: privateKey.n ? 'RSA' : 'Inconnu', // simplifié : présence de "n" → RSA
          length: privateKey.n?.bitLength() || 'Inconnu'
        }
      } catch (err) {
        console.error('Erreur de parsing de la clé privée :', err)
        return null
      }
    },
    resetFieldForm(){
      this.hasMainFile = true
      this.CertificateInput = null
      this.PrivateKeyInput = null
      this.ExtractDataFromHeader = null
      this.Cert = ''

    },
    getAttributeValue (attributes, name) {
      const attr = attributes.find(attr => attr.name === name);
      return attr ? attr.value : 'Inconnu';
    }
  }
}

</script>
